module.exports = __webpack_public_path__ + "img/roth.21ef110c.svg";